module.exports = __webpack_public_path__ + "img/Boy_020001.53f07d32.png";